// @flow
import * as React from 'react';

import CheckMark from './CheckMark';

import styles from './CheckedList.scss';

type Props = {
  items: Array<string>,
};

function CheckedList({ items }: Props) {
  return (
    <ol className={styles.list}>
      {items.map((value, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>
          <CheckMark />
          <span>{value}</span>
        </li>
      ))}
    </ol>
  );
}

export default (React.memo<Props>(CheckedList): React.ComponentType<Props>);
